module.exports = __webpack_public_path__ + "img/BH4-MAJ-EXT-lowres-1059.1d6be821.jpg";